module.exports = __webpack_public_path__ + "img/11d.561ad8bc.gif";